import { apiCredSystemInvoices } from '~/credsystem/services/apiCredSystem';

interface APIResponseDto {
  linha_digitavel: string;
}

export async function getCredsystemBarCode(
  invoiceId: string
): Promise<string | null> {
  try {
    const response = await apiCredSystemInvoices.get<APIResponseDto>(
      `/extrato/api/v1/linha-digitavel/` + invoiceId
    );

    return response.data.linha_digitavel;
  } catch (error) {
    return null;
  }
}
